const CSRF_COOKIE = "XSRF-TOKEN";
const CSRF_ENDPOINT = "/api/auth/csrf";

let csrfToken: string | null = null;
let csrfHeaderName = "X-XSRF-TOKEN";
let csrfPromise: Promise<void> | null = null;

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  const value = match?.[1];
  return value !== undefined ? decodeURIComponent(value) : null;
}

/** Fetches the token once, however many requests ask for it at the same time. */
function fetchCsrfToken(): Promise<void> {
  csrfPromise ??= fetch(CSRF_ENDPOINT, { credentials: "same-origin" })
    .then(async (res) => {
      if (!res.ok) return;
      const data = (await res.json()) as { headerName?: string; token?: string };
      if (data.headerName) csrfHeaderName = data.headerName;
      csrfToken = data.token ?? readCookie(CSRF_COOKIE);
    })
    .finally(() => {
      csrfPromise = null;
    });
  return csrfPromise;
}

async function ensureCsrfToken(): Promise<void> {
  const existing = readCookie(CSRF_COOKIE);
  if (existing) {
    csrfToken = existing;
    return;
  }
  await fetchCsrfToken();
}

/**
 * The header that proves a state-changing request comes from the suite: the XSRF-TOKEN cookie
 * echoed back (fetching GET /api/auth/csrf first when the cookie does not exist yet). Empty
 * when no token could be obtained.
 */
export async function csrfHeaders(): Promise<Record<string, string>> {
  await ensureCsrfToken();
  return csrfToken ? { [csrfHeaderName]: csrfToken } : {};
}
